export default "__VITE_ASSET__CnxLc5VJ__"